import { StaffPositionEnum } from '../../../../lib/types/enums/staff/staff-position.enum'
import StaffAdministrativeDocumentsForm from '../staff-form/staff-administrative-documents-form'
import StaffAvailabilitiesSection from '../staff-form/staff-availabilities-section'
import StaffJourneysSection from '../staff-form/staff-journeys-section'
import StaffMissionsSection from '../staff-form/staff-missions-section'
import StaffPersonalInformationForm from '../staff-form/staff-personal-information-form'
import StaffProfessionalInformationForm from '../staff-form/staff-professional-information-form'
import StaffRecrutementForm from '../staff-form/staff-recrutement-form'

// Define a type for accordion states
export type AccordionStates = {
  [key: string]: boolean
}

export const COMMENTS_SECTION_ID = 'staff-comments'

export const accordionItems = [
  'item-1',
  'item-2',
  'item-3',
  'item-4',
  'item-5',
  'item-6',
  'item-7'
] as const

export type AccordionItemKey = (typeof accordionItems)[number]

// Section opened by default on an existing staff profile, depending on the position
const defaultOpenItemByPosition: Record<StaffPositionEnum, AccordionItemKey> = {
  [StaffPositionEnum.ANIMATOR]: 'item-6',
  [StaffPositionEnum.TEACHER]: 'item-6',
  [StaffPositionEnum.AAT]: 'item-7'
}

export const getInitialAccordionStates = (position?: StaffPositionEnum): AccordionStates =>
  accordionItems.reduce(
    (acc, item) => ({
      ...acc,
      [item]: !!position && defaultOpenItemByPosition[position] === item
    }),
    {}
  )

export type StaffFormCommonProps = {
  mode: 'create' | 'update'
  staffId?: number
}

export type AccordionContentMap = {
  [K in AccordionItemKey]: {
    accordionText: string
    tabText: string
    content: (props: StaffFormCommonProps) => React.ReactNode
  }
}

// Define the mapping with strict typing
export const accordionContentMap: AccordionContentMap = {
  'item-1': {
    accordionText: 'Détails personnels',
    tabText: 'Civilité',
    content: () => <StaffPersonalInformationForm />
  },
  'item-2': {
    accordionText: 'Disponibilités',
    tabText: 'Disponibilité',
    content: () => <StaffAvailabilitiesSection />
  },
  'item-3': {
    accordionText: 'Détails du recrutement',
    tabText: 'Recrutement',
    content: (props) => <StaffRecrutementForm {...props} />
  },
  'item-4': {
    accordionText: 'Détails professionnels',
    tabText: 'Professionnel',
    content: () => <StaffProfessionalInformationForm />
  },
  'item-5': {
    accordionText: 'Documents administratifs',
    tabText: 'Administratif',
    content: ({ staffId }) => <StaffAdministrativeDocumentsForm staffId={staffId} />
  },
  'item-6': {
    accordionText: 'Séjours',
    tabText: 'Séjours',
    content: ({ staffId }) => <StaffJourneysSection staffId={staffId} />
  },
  'item-7': {
    accordionText: 'Missions',
    tabText: 'Missions',
    content: ({ staffId }) => <StaffMissionsSection staffId={staffId} />
  }
}
